<template>
  <div>
    <el-dialog
      :title="$t('lang.提示')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <div class="token_container">
        <i class="iconfont icon-big"></i>
        <div>
          {{ $t("lang.您的设备为键盘表需要手动输入Token进行")
          }}{{ operationText }}，{{ $t("lang.本次") }}{{ operationText }}Token{{
            $t("lang.为")
          }}:{{ token }}
          <i class="el-icon-copy-document" @click="onClickCopy"></i>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">{{
          $t("lang.确定")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      token: "",
      operationText: "",
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    showDialog(token, operationText) {
      this.dialogVisible = true;
      this.token = token;
      this.operationText = operationText;
    },
    onClickCopy() {
      let input = document.createElement("input");
      input.value = this.token;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
  },
};
</script>

<style scoped lang='less'>
/deep/.el-dialog {
  width: 678px !important;
}
/deep/.el-dialog__body {
  padding: 30px 100px 10px;
}
.token_container {
  display: flex;
  font-size: 18px;
  color: #333;
  i {
    color: #ffb040;
    font-size: 24px;
    margin-right: 10px;
  }
  div i {
    color: #409eff;
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
  }
}
</style>